import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@heroui/react";
import { ArrowLeftRight } from "lucide-react";

/**
 * EDI 連携先。得意先ごとに手順が違うため、押してから選ばせる。
 *
 * 連携そのものは未実装。向き（取り込み／送信）・方式（ファイル／API）・対象
 * （見積依頼／見積回答／注文）が決まっていないため、いまは選んだ先が伝わる
 * ところまでにしてある。
 */
const EDI_PARTNERS = [
  { key: "kyocera", label: "京セラ" },
  { key: "hirata", label: "平田機工" },
];

/**
 * 「EDI連携」ボタンと連携先メニュー。置き場所は**見積一覧だけ**。
 *
 * 見積詳細にも置いていたが、そちらは依頼の取り込みではなく回答の送信が要る
 * 場所で、回答ファイルの書き出しがその役を果たすようになったため外した。
 */
export default function EdiMenuButton({
  onSelect,
}: {
  /** 連携先が選ばれたときに呼ぶ。 */
  onSelect: (partnerKey: string, partnerLabel: string) => void;
}) {
  return (
    <Dropdown>
      <DropdownTrigger>
        <Button
          radius="full"
          variant="bordered"
          data-testid="edi-menu"
          startContent={<ArrowLeftRight size={18} />}
        >
          EDI連携
        </Button>
      </DropdownTrigger>
      <DropdownMenu
        aria-label="EDI連携"
        onAction={(key) => {
          const partner = EDI_PARTNERS.find((p) => p.key === key);
          if (!partner) return;
          onSelect(partner.key, partner.label);
        }}
      >
        {EDI_PARTNERS.map((partner) => (
          <DropdownItem key={partner.key}>{partner.label}</DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}
